// Single place every animated component checks before moving. The React Bits
// components take a disabled/skip flag rather than reading the media query
// themselves, so this keeps the check consistent (and SSR-safe if that ever
// matters) instead of scattering matchMedia calls per page.
export function prefersReducedMotion() {
  return (
    typeof window !== 'undefined' &&
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
}
